import {getInitialAppContext} from '../../../utils/appContext';

const appContext = getInitialAppContext();

export const generateWidgetConfig= (releaseVersion, stackName, period) => [
  {
    title: `Orchestrator Release Metrics - ${releaseVersion}`,
    metrics: [
      {
        alias: 'PENDING',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.PENDING',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'TO_SCHEDULE',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.TO_SCHEDULE',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'SCHEDULED',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.SCHEDULED',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },

      {
        alias: 'QUEUED',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.QUEUED',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'PENDING_CLUSTER_PROVISION',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.PENDING_CLUSTER_PROVISION',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'IN_PROGRESS',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.IN_PROGRESS',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'SUCCESS',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.SUCCESS',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'FAILED',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.FAILED',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'VALIDATION_FAILED',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.VALIDATION_FAILED' ,
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      },
      {
        alias: 'ABORTED',
        namespace: 'sdpdservice',
        metric_name: 'OrchestratorManager.Release.ABORTED',
        stats: ['Maximum'],
        dimensions: [
          { name: 'Program', value: 'sdpdservice' },
          { name: 'MetricClass', value: stackName },
          { name: 'Instance', value: releaseVersion }
        ],
        account_id: appContext.sdpdsAccountId
      }
    ],
    view: "timeSeries",
    stacked: true,
    period: period,
  },
];